export const globalReportFiltersTypes = {
    set: "[globalReportFilters] set",
    clean: "[globalReportFilters] clean",
};
